import { startOfToday } from 'date-fns';
import { z } from 'zod';

// Validates that the date is today or in the future
export const TodayOrFutureDate = z.date().min(startOfToday());
